const tnZA= {
    login: {
      title: 'Tsena mo Teng',
      sign_in_btn: 'Tsena mo Teng'
    },
    bar: {
        logout: 'Tswaya',
        languages: 'Dipuo',
        settings: 'Bula diseting'
    },
    language: {
      name: 'Setswana (SA)',
    },
    attributePage: {
        title: 'Dikarolo Tsa Diphetogo',
        viewChanges: 'Bona Diphetogo',
        dateTime: 'Letlha',
        notificationType: 'Mofuta wa Tlhagiso',
        notificationValue: 'Tlhagiso e Kgonang go Dirisiwa',
        oldValue: 'E Kgonang go Dirisiwa ya Kgale',
        newValue: 'E Ntšha e Kgonang go Dirisiwa',
        accept: 'Amogela',
        reject: 'Gana',
    },
    Home: 'Tshimologo',
    load: 'Go tsenya la ntlha...',
    Requested: "Kopilwe",
    Viewed: "Lebilwe",
    Executing: "Go Diragatsa",
    Completed: "Weditswe",
    Expired: "Feletswe ke Nako",
    Cancelled: "Khansetswe",
    Error: "Phoso",
    Rejected: "Gannwe",
    error: 'Sengwe se nnile phoso; tsweetswee leka gape moragonyana.',
    displayname: 'Leina la go Bontsha',
    givenname: 'Leina',
    surname: 'Sefane',
    email: 'Imeile',
    mail: 'Imeile',
    name: 'Leina',
    firstname: 'Leina',
    lastname: 'Sefane',
    footer_copyright: 'Ditshwanelo tsotlhe di sireleditswe.'
  };
  
  export default tnZA;
  